import PropTypes from 'prop-types';
import pinUrl from './pin.svg';

export const YOU_PIN_ICON_URL = pinUrl;

export const YouPinIcon = ({ size = 20, alt = '' }) => (
  <img
    src={pinUrl}
    alt={alt}
    width={size}
    height={size}
    data-testid="you-pin-icon"
  />
);

YouPinIcon.propTypes = {
  size: PropTypes.number,
  alt: PropTypes.string,
};

export default YouPinIcon;
